import React, { useState } from "react";
import { Form, Row, Col, Button, Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logo_dark from "../assets/img/logo.png";
import { emailNotification } from "../common/api";
import { ShowToast } from "../common/function";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      newErrors.email = "Enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  console.log("email");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");
    if (!validateForm()) return;

    try {
      setLoading(true);
      const response = await emailNotification({ email: email.trim() });
      setLoading(false);

      if (response.success) {
        ShowToast(1, "OTP sent successfully");
        navigate("/otp", { state: { email: email } });
      } else {
        ShowToast(0, response.message || "Something went wrong");
      }
    } catch (err) {
      setLoading(false);
      setApiError("Something went wrong. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo_dark} alt="" />
              <h2>
                Forgot <span>Password</span>
              </h2>
              <p>
                Please enter your email address to receive an OTP for password
                reset.
              </p>
            </div>

            <Form onSubmit={handleSubmit}>
              {errors && errors.email && (
                <Alert variant="danger" className="mb-3">
                  {errors.email}
                </Alert>
              )}

              <Form.Group className="mb-4 form-group">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email address"
                  value={email}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEmail(value);

                    if (errors.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }
                  }}
                  isInvalid={!!errors.email}
                />
                {/* <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback> */}
              </Form.Group>

              <Button
                type="submit"
                className="btn btn-primary w-100 mt-3"
                disabled={loading}
              >
                {loading ? "Sending..." : "Proceed"}
              </Button>

              <p className="formfooter text-center mt-3">
                Back To <Link to="/">Login</Link>
              </p>
            </Form>
          </div>
        </Col>

        <Col lg={6} className="loginmb_none">
          <div className="loginlogo_div">
            <Link to="/">
              <img src={logo_dark} alt="" />
            </Link>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}
